<template>
  <div>
    <div v-if="loading" class="loading-msg">
      <i class="pi pi-spin pi-spinner" /> Cargando agentes...
    </div>
    <div v-else-if="agents.length === 0" class="empty-msg">
      No hay agentes disponibles.
    </div>
    <div v-else class="agents-grid">
      <AgentCard v-for="agent in agents" :key="agent.id" :agent="agent" @chat="$emit('chat', $event)" />
    </div>
  </div>
</template>

<script setup>
import AgentCard from './AgentCard.vue';

defineProps({
  agents: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
});
defineEmits(['chat']);
</script>

<style scoped>
.agents-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(260px, 1fr)); gap: 1.5rem; }
.loading-msg, .empty-msg { text-align: center; padding: 3rem; color: #9ca3af; }
</style>
